import React from 'react';
import cn from 'classnames';
import { colors } from '../../config';

const Pill = ({
  id,
  name,
  register,
  value,
  defaultChecked,
  label,
  checkbox,
  active = false,
  onChange,
  unique,
  ...rest
}) => (
  <div>
    <input
      id={id}
      type={checkbox ? 'checkbox' : 'radio'}
      name={name}
      ref={register}
      value={value}
      defaultChecked={defaultChecked}
      onChange={onChange}
      data-unique={unique}
    />

    <label htmlFor={id} className={cn('pill', { active: active })} {...rest}>
      {label}
    </label>

    <style jsx>{`
      div {
        display: inline-block;
      }

      .pill {
        border: 1px solid ${colors.orange};
        border-radius: 999px;
        padding: 4px 15px;
        margin-top: 2px;
        margin-bottom: 10px;
        display: inline-block;
        min-width: 68px;
        text-align: center;
        cursor: pointer;
        color: ${colors.orange};
        background-color: transparent;
        transition: background-color 0.35s ease;
        user-select: none;
      }

      .pill:hover {
        background-color: #fff;
      }

      input {
        margin: 0;
        opacity: 0;
        position: absolute;
      }

      input:focus + .pill {
        outline: ${colors.outline};
      }

      input:checked ~ label,
      .pill.active {
        background-color: ${colors.orange};
        color: #fff;
      }
    `}</style>
  </div>
);

export default Pill;
